import { TranslationMapType } from '@/modules/common/types/i18n';

import logger from '@/modules/common/helpers/logger';

export const DEFAULT_SUPPORTED_LANGUAGE = 'en';

export const supportedLanguages = [
  DEFAULT_SUPPORTED_LANGUAGE,
  // 'af',
  // 'ar',
  // 'az',
  // 'bg',
  // 'ca',
  // 'cs',
  // 'da',
  // 'de',
  // 'el',
  // 'es',
  // 'et',
  // 'fa',
  // 'fi',
  // 'fr',
  // 'gu',
  'he',
  // 'hi',
  // 'hr',
  // 'hu',
  // 'hy',
  // 'id',
  // 'is',
  // 'it',
  // 'ja',
  // 'km',
  // 'kn',
  // 'ko',
  // 'lt',
  // 'lv',
  // 'mk',
  // 'ml',
  // 'mr',
  // 'ms',
  // 'ne',
  // 'nl',
  // 'pl',
  // 'pt',
  // 'ro',
  // 'ru',
  // 'sk',
  // 'sl',
  // 'sq',
  // 'sr',
  // 'sv',
  // 'sw',
  // 'ta',
  // 'te',
  // 'th',
  // 'tl',
  // 'tr',
  // 'uk',
  // 'vi',
] as const;

export const locales: Record<(typeof supportedLanguages)[number], () => Promise<TranslationMapType>> = {
  en: () => import('../i18n/en.json').then((m) => m.default),
  he: () => import('../i18n/he.json').then((m) => m.default),
};

export const dayjsLocales: Record<(typeof supportedLanguages)[number], () => Promise<unknown>> = {
  en: () => import('dayjs/locale/en'),
  he: () => import('dayjs/locale/he'),
};

if (process.env.NODE_ENV === 'development') {
  Promise.all(Object.entries(locales).map(async ([lang, load]) => [lang, await load()] as const))
    .then((entries) => {
      const map = Object.fromEntries(entries);
      const base = map[DEFAULT_SUPPORTED_LANGUAGE];

      Object.entries(map).forEach(([lang, keys]) => {
        if (lang === DEFAULT_SUPPORTED_LANGUAGE) return;

        Object.keys(base).forEach((key) => {
          if (!(key in keys)) {
            // eslint-disable-next-line no-alert
            window.alert(`Missing key in "src/modules/common/i18n/${lang}.json": "${key}"`);
          }
        });
      });
    })
    .catch(logger.error);
}

export const defaultDateTimeFormat: Record<(typeof supportedLanguages)[number], string> = {
  en: 'MMM D, YYYY hh:mm A',
  he: 'D MMM YYYY HH:mm',
};
